module.exports = __webpack_public_path__ + "static/media/ayti_logo.b969b976.jpg";